import template from './addFundingObligationModal.html';
import controller from './addFundingObligationModal.controller';

let AddFundingObligationModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

AddFundingObligationModalComponent.template = template;
AddFundingObligationModalComponent.controller = controller;

export default AddFundingObligationModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/addFundingObligationModal/addFundingObligationModal.component.js